import React, { useState, useEffect } from 'react';
import { FaEye, FaEdit, FaTrash } from 'react-icons/fa';
import '../../assets/styles/table-styles.css';
import '../../assets/styles/filtros-styles.css';
import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import Sidebar from "../../components/Sidebar";
import { blogimg10, imagesend, pdficon, pdficon3, pdficon4, plusicon, refreshicon, searchnormal, blogimg12,
  blogimg2, blogimg4, blogimg6, blogimg8} from '../../components/imagepath';
import { FiChevronRight, FiFilter, FiRotateCcw, FiRefreshCw } from "react-icons/fi";
import {onShowSizeChange,itemRender}from  '../../components/Pagination';
import { Table } from 'antd';
import { BaseInput, BaseSelect, BaseButton, BaseTextarea } from '../../components/ui';
import { useAuth } from "../../utils/AuthContext";
import inmuebleService from "../../services/inmuebleService";
import espacioService from "../../services/espacioService";
import pisoService from "../../services/pisoService";
import tipoespacioService from "../../services/tipoespacioService";
import '../../assets/styles/form-styles.css';
import '../../assets/styles/EspaciosRegistrar.css';
import { message, Spin, Alert, Modal } from 'antd';
import { useNavigate } from 'react-router-dom';
import useCanDelete from '../../hooks/useCanDelete';
import { SearchOutlined, PlusOutlined, EditOutlined, DeleteOutlined, FileExcelOutlined } from '@ant-design/icons';
import * as XLSX from 'xlsx';

const EspaciosRegistros = () => {
  const { user, estaAutenticado, token } = useAuth();
  const canDelete = useCanDelete();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [espacios, setEspacios] = useState([]);
  const [espaciosFiltrados, setEspaciosFiltrados] = useState([]);
  const [inmuebles, setInmuebles] = useState([]);
  const [pisos, setPisos] = useState([]);
  const [tipoEspacios, setTipoEspacios] = useState([]);
  const [selectedInmueble, setSelectedInmueble] = useState('');
  const [selectedPiso, setSelectedPiso] = useState('');
  const [selectedTipoEspacio, setSelectedTipoEspacio] = useState('');
  const [searchText, setSearchText] = useState('');
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [modalEditVisible, setModalEditVisible] = useState(false);
  const [modalViewVisible, setModalViewVisible] = useState(false);
  const [espacioSeleccionado, setEspacioSeleccionado] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [updatedData, setUpdatedData] = useState(null);
  const [formData, setFormData] = useState({
    nombre: '',
    descripcion: '',
    precio: '',
    capacidad: '',
    bano: '',
    tipoEspacio_id: ''
  });
  const navigate = useNavigate();

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const onChange = (date, dateString) => {
    // console.log(date, dateString);
  };

  // Verificar autenticación
  useEffect(() => {
    if (!estaAutenticado) {
      navigate('/login');
    }
  }, [estaAutenticado, navigate]);

  // Cargar datos iniciales
  useEffect(() => {
    const cargarDatosIniciales = async () => {
      if (!estaAutenticado) return;

      setLoading(true);
      setError(null);
      try {
        // Cargar inmuebles
        const inmueblesData = await inmuebleService.obtenerInmuebles();
      
        setInmuebles(Array.isArray(inmueblesData) ? inmueblesData : []);

        // Cargar tipos de espacio
        const tiposData = await tipoespacioService.obtenerTodos();
        setTipoEspacios(Array.isArray(tiposData) ? tiposData : []);

        // Cargar todos los espacios
        const espaciosData = await espacioService.obtenerEspacios();
        const espaciosArray = Array.isArray(espaciosData) ? espaciosData : [];
        setEspacios(espaciosArray);
        setEspaciosFiltrados(espaciosArray);
      } catch (error) {
        console.error('Error al cargar datos iniciales:', error);
        setError('Error al cargar los datos');
        setEspacios([]);
        setEspaciosFiltrados([]);
      } finally {
        setLoading(false);
      }
    };

    cargarDatosIniciales();
  }, [estaAutenticado]);

  // Cargar pisos cuando se selecciona un inmueble
  useEffect(() => {
    const cargarPisos = async () => {
      if (!selectedInmueble || !estaAutenticado) {
        setPisos([]);
        return;
      }

      try {
        const pisosData = await pisoService.obtenerPorInmueble(selectedInmueble);
        setPisos(Array.isArray(pisosData) ? pisosData : []);
        setSelectedPiso('');
      } catch (error) {
        console.error('Error al cargar pisos:', error);
        setPisos([]);
      }
    };

    cargarPisos();
  }, [selectedInmueble, estaAutenticado]);

  // Aplicar filtros
  useEffect(() => {
    let filtered = [...espacios];
   

    // Filtrar por texto de búsqueda
    if (searchText) {
      const searchLower = searchText.toLowerCase();
      filtered = filtered.filter(espacio =>
        espacio.nombre.toLowerCase().includes(searchLower) ||
        espacio.descripcion.toLowerCase().includes(searchLower) ||
        espacio.inmueble_nombre?.toLowerCase().includes(searchLower) ||
        espacio.piso_nombre?.toLowerCase().includes(searchLower)
      );
    }

    // Filtrar por inmueble
    if (selectedInmueble) {
      filtered = filtered.filter(espacio => espacio.inmueble_id === parseInt(selectedInmueble));
    }

    // Filtrar por piso
    if (selectedPiso) {
      filtered = filtered.filter(espacio => espacio.piso_id === parseInt(selectedPiso));
    }

    // Filtrar por tipo de espacio
    if (selectedTipoEspacio) {
      filtered = filtered.filter(espacio => espacio.tipoEspacio_id === parseInt(selectedTipoEspacio));
    }

    setEspaciosFiltrados(filtered);
  }, [espacios, selectedInmueble, selectedPiso, selectedTipoEspacio, searchText]);

  const handleInmuebleChange = (e) => {
    setSelectedInmueble(e.target.value);
  };

  const handlePisoChange = (e) => {
    setSelectedPiso(e.target.value);
  };

  const handleTipoEspacioChange = (e) => {
    setSelectedTipoEspacio(e.target.value);
  };

  const handleSearch = (value) => {
    setSearchText(value);
  };

  const handleExport = () => {
    // Implementar lógica de exportación
    message.success('Exportación iniciada');
  };

  const handleEdit = (record) => {
    setEspacioSeleccionado(record);
    setFormData({
      nombre: record.nombre,
      descripcion: record.descripcion,
      precio: record.precio,
      capacidad: record.capacidad,
      bano: record.baño,
      tipoEspacio_id: record.tipoEspacio_id
    });
    setModalEditVisible(true);
  };

  const handleDelete = async (record) => {
    if (!estaAutenticado) {
      message.error('No hay sesión activa');
      return;
    }

    try {
      await espacioService.eliminarEspacio(record.inmueble_id, record.piso_id, record.id);
      message.success('Espacio eliminado correctamente');
      
      // Recargar espacios
      const espaciosData = await espacioService.obtenerEspacios();
      setEspacios(Array.isArray(espaciosData) ? espaciosData : []);
    } catch (error) {
      message.error('Error al eliminar el espacio');
    }
  };

  const handleSubmitEdit = async (e) => {
    e.preventDefault();
    if (!estaAutenticado) {
      message.error('No hay sesión activa');
      return;
    }

    try {
      await espacioService.actualizarEspacio(
        espacioSeleccionado.inmueble_id,
        espacioSeleccionado.piso_id,
        espacioSeleccionado.id,
        formData
      );

      // Guardar los datos actualizados y mostrar el modal de éxito
      setUpdatedData(formData);
      setModalEditVisible(false);
      setShowSuccessModal(true);

    } catch (error) {
      console.error('Error al actualizar el espacio:', error);
      Modal.error({
        title: 'Error en la Actualización',
        content: `No se pudo actualizar el espacio: ${error.response?.data?.message || error.message || 'Error desconocido'}`,
        okText: 'Aceptar'
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleView = (record) => {
    setEspacioSeleccionado(record);
    setModalViewVisible(true);
  };

  // Agregar nueva función para limpiar filtros 
  const handleLimpiarFiltros = () => {
    setSelectedInmueble('');
    setSelectedPiso('');
    setSelectedTipoEspacio('');
    setSearchText('');
  };

  // Función para manejar el cierre del modal de éxito
  const handleSuccessModalClose = () => {
    setShowSuccessModal(false);
    // Recargar espacios
    refreshData();
  };

  // Función para recargar los datos
  const refreshData = async () => {
    try {
      setLoading(true);
      setError(null);
      
      // Cargar inmuebles
      const inmueblesData = await inmuebleService.obtenerInmuebles();
      setInmuebles(Array.isArray(inmueblesData) ? inmueblesData : []);

      // Cargar tipos de espacio
      const tiposData = await tipoespacioService.obtenerTodos();
      setTipoEspacios(Array.isArray(tiposData) ? tiposData : []);

      // Cargar todos los espacios
      const espaciosData = await espacioService.obtenerEspacios();
      const espaciosArray = Array.isArray(espaciosData) ? espaciosData : [];
      setEspacios(espaciosArray);
      setEspaciosFiltrados(espaciosArray);
      
      message.success('Datos actualizados correctamente');
    } catch (error) {
      console.error('Error al actualizar los datos:', error);
      setError('Error al cargar los datos');
      message.error('Error al actualizar los datos');
    } finally {
      setLoading(false);
    }
  };

  // Función para exportar a Excel
  const exportToExcel = () => {
    try {
      const dataForExcel = espaciosFiltrados.map(item => ({
        'Inmueble': item.inmueble_nombre || '',
        'Piso': item.piso_nombre || '',
        'Nombre': item.nombre || '',
        'Tipo': item.tipo_espacio || '',
        'Descripción': item.descripcion || '',
        'Precio': item.precio ? `S/ ${parseFloat(item.precio).toFixed(2)}` : '',
        'Capacidad': item.capacidad || '',
        'Baño': item.baño === 'propio' ? 'Propio' : 'Compartido',
        'Estado': item.estado === 0 ? 'Desocupado' : 'Ocupado'
      }));
      // Crear libro de Excel
      const ws = XLSX.utils.json_to_sheet(dataForExcel);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Espacios");
      // Guardar archivo
      const fecha = new Date().toISOString().slice(0,10);
      const fileName = `Espacios_${fecha}.xlsx`;
      XLSX.writeFile(wb, fileName);
      message.success('Reporte exportado exitosamente');
    } catch (error) {
      console.error('Error al exportar a Excel:', error);
      message.error('Error al exportar el reporte');
    }
  };

  const columns = [
    {
      title: "Inmueble",
      dataIndex: "inmueble_nombre",
      key: "inmueble_nombre",
      sorter: (a, b) => a.inmueble_nombre?.localeCompare(b.inmueble_nombre || ''),
      render: (text) => text || "N/A",
    },
    {
      title: "Piso",
      dataIndex: "piso_nombre",
      key: "piso_nombre",
      sorter: (a, b) => a.piso_nombre?.localeCompare(b.piso_nombre || ''),
      render: (text) => text || "N/A",
    },
    {
      title: "Nombre",
      dataIndex: "nombre",
      key: "nombre",
      sorter: (a, b) => a.nombre.localeCompare(b.nombre),
    },
    {
      title: "Tipo",
      dataIndex: "tipo_espacio",
      key: "tipo_espacio",
      sorter: (a, b) => a.tipo_espacio.localeCompare(b.tipo_espacio),
    },
    {
      title: "Descripción",
      dataIndex: "descripcion",
      key: "descripcion",
      sorter: (a, b) => a.descripcion.localeCompare(b.descripcion),
    },
    {
      title: "Precio",
      dataIndex: "precio",
      key: "precio",
      sorter: (a, b) => parseFloat(a.precio) - parseFloat(b.precio),
      render: (precio) => {
        const precioNumero = parseFloat(precio);
        return isNaN(precioNumero) ? 'S/ 0.00' : `S/ ${precioNumero.toFixed(2)}`;
      }
    },
    {
      title: "Capacidad",
      dataIndex: "capacidad",
      key: "capacidad",
      sorter: (a, b) => a.capacidad - b.capacidad,
    },
    {
      title: "Baño",
      dataIndex: "baño",
      key: "baño",
      render: (bano) => bano === 'propio' ? 'Propio' : 'Compartido'
    },
    {
      title: "Estado",
      dataIndex: "estado",
      key: "estado",
      render: (estado) => estado === 0 ? 'Desocupado' : 'Ocupado'
    },
    {
      title: "Acciones",
      key: "acciones",
      align: "center",
      render: (_, record) => (
        <div className="d-flex justify-content-center">
          <BaseButton
            type="button"
            variant="primary"
            size="sm"
            className="mx-1"
            icon={<i className="fas fa-eye" />}
            onClick={() => handleView(record)}
            title="Ver detalles"
          />
          <BaseButton
            type="button"
            variant="warning"
            size="sm"
            className="mx-1"
            icon={<i className="fas fa-edit" />}
            onClick={() => handleEdit(record)}
            title="Editar"
          />
          {canDelete && (
            <BaseButton
              type="button"
              variant="danger"
              size="sm"
              className="mx-1"
              icon={<i className="fas fa-trash" />}
              onClick={() => handleDelete(record)}
              title="Eliminar"
            />
          )}
        </div>
      ),
    },
  ];

  if (loading) {
    return (
      <div className="page-wrapper">
        <div className="content">
          <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Cargando...</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
    <Header />
    <Sidebar id='menu-item3' id1='menu-items3' activeClassName='espacios-registros'/>
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="row">
            <div className="col-sm-12">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="#">Espacios</Link>
                </li>
                <li className="breadcrumb-item">
                  <i className="feather-chevron-right">
                    <FiChevronRight />
                  </i>
                </li>
                <li className="breadcrumb-item active">Lista de Espacios</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12">
            <div className="card card-table show-entire">
              <div className="card-body">
                {error && (
                  <div className="alert alert-danger" role="alert">
                    {error}
                  </div>
                )}

                <div className="page-table-header mb-2">
                  <div className="row align-items-center">
                    <div className="col">
                      <div className="doctor-table-blk">
                        <h3>Lista de Espacios</h3>
                        <div className="doctor-search-blk">
                          <div className="top-nav-search table-search-blk">
                            <BaseInput
                              placeholder="Buscar aquí"
                              value={searchText}
                              onChange={(e) => handleSearch(e.target.value)}
                              wrapperClassName="mb-0"
                            />
                          </div>
                          <div className="add-group">
                            <BaseButton
                              type="button"
                              variant="primary"
                              className="ms-2 add-pluss"
                              title="Añadir espacio"
                              icon={<img src={plusicon} alt="Añadir" />}
                              onClick={() => navigate('/espacios-anadir')}
                            />
                            <BaseButton
                              type="button"
                              variant="primary"
                              className="ms-2 doctor-refresh"
                              onClick={refreshData}
                              title="Actualizar datos"
                              loading={loading}
                              icon={<FiRefreshCw />}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-auto text-end float-end ms-auto download-grp">
                      <BaseButton
                        type="button"
                        variant="success"
                        className="ms-2"
                        icon={<FileExcelOutlined />}
                        onClick={exportToExcel}
                        title="Exportar a Excel"
                      />
                    </div>
                  </div>
                </div>

                <div className="staff-search-table">
                  <div className="card mb-4">
                    {/*<div className="card-header bg-light">
                      <h5 className="mb-0">
                        <i className="fas fa-filter me-2"></i>
                        Filtros de búsqueda
                      </h5>
                    </div>*/}
                    <div className="card-body">
                      <form>
                        <div className="row g-3">
                          <div className="col-12 col-md-4">
                            <BaseSelect
                              label="Inmueble"
                              name="inmuebleId"
                              isSearchable
                              isClearable
                              value={selectedInmueble}
                              onChange={handleInmuebleChange}
                              placeholder="Todos los inmuebles"
                              options={inmuebles.map((i) => ({ value: i.id, label: i.nombre }))}
                            />
                          </div>
                          <div className="col-12 col-md-4">
                            <BaseSelect
                              label="Piso"
                              name="pisoId"
                              isSearchable
                              isClearable
                              value={selectedPiso}
                              onChange={handlePisoChange}
                              disabled={!selectedInmueble}
                              placeholder="Todos los pisos"
                              options={pisos.map((p) => ({ value: p.id, label: p.nombre }))}
                            />
                          </div>
                          <div className="col-12 col-md-4">
                            <BaseSelect
                              label="Tipo de Espacio"
                              name="tipoEspacioId"
                              isSearchable
                              isClearable
                              value={selectedTipoEspacio}
                              onChange={handleTipoEspacioChange}
                              placeholder="Todos los tipos"
                              options={tipoEspacios.map((t) => ({ value: t.id, label: t.nombre }))}
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12 d-flex justify-content-end gap-2 mb-3 mt-2">
                            <BaseButton type="button" variant="primary" icon={<FiFilter />}>
                              Aplicar filtros
                            </BaseButton>
                            <BaseButton
                              type="button"
                              variant="secondary"
                              icon={<FiRotateCcw />}
                              onClick={handleLimpiarFiltros}
                            >
                              Limpiar
                            </BaseButton>
                          </div>
                        </div>
                      </form>
                      {(selectedInmueble || selectedPiso || selectedTipoEspacio || searchText) && (
                        <div className="alert alert-info mt-3">
                          <strong>Filtros aplicados:</strong>
                          {selectedInmueble && (
                            <span className="badge bg-primary me-2">
                              Inmueble: {inmuebles.find(i => i.id === parseInt(selectedInmueble))?.nombre}
                            </span>
                          )}
                          {selectedPiso && (
                            <span className="badge bg-primary me-2">
                              Piso: {pisos.find(p => p.id === parseInt(selectedPiso))?.nombre}
                            </span>
                          )}
                          {selectedTipoEspacio && (
                            <span className="badge bg-primary me-2">
                              Tipo: {tipoEspacios.find(t => t.id === parseInt(selectedTipoEspacio))?.nombre}
                            </span>
                          )}
                          {searchText && (
                            <span className="badge bg-primary me-2">
                              Búsqueda: {searchText}
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="table-responsive">
                  <Table
                    columns={columns}
                    dataSource={espaciosFiltrados}
                    rowKey="id"
                    pagination={{
                      total: espaciosFiltrados.length,
                      showTotal: (total, range) =>
                        `Mostrando ${range[0]} de ${range[1]} de ${total} registros`,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Modal de Edición */}
    <Modal
      title="Editar Espacio"
      open={modalEditVisible}
      onCancel={() => setModalEditVisible(false)}
      footer={null}
      width={800}
    >
      {espacioSeleccionado && (
        <form onSubmit={handleSubmitEdit}>
          <div className="row g-3">
            <div className="col-12 col-md-6">
              <BaseInput
                label="Nombre"
                name="nombre"
                required
                value={formData.nombre}
                onChange={handleChange}
              />
            </div>

            <div className="col-12 col-md-6">
              <BaseSelect
                native
                label="Tipo de Espacio"
                name="tipoEspacio_id"
                required
                value={formData.tipoEspacio_id}
                onChange={handleChange}
                placeholder="Seleccionar tipo"
                options={tipoEspacios.map((tipo) => ({ value: tipo.id, label: tipo.nombre }))}
              />
            </div>

            <div className="col-12">
              <BaseTextarea
                label="Descripción"
                name="descripcion"
                required
                rows={3}
                value={formData.descripcion}
                onChange={handleChange}
              />
            </div>

            <div className="col-12 col-md-6">
              <BaseInput
                label="Precio"
                name="precio"
                type="number"
                required
                restrict="decimal"
                min="0"
                step="0.01"
                value={formData.precio}
                onChange={handleChange}
                startIcon={<span>S/</span>}
              />
            </div>

            <div className="col-12 col-md-6">
              <BaseInput
                label="Capacidad"
                name="capacidad"
                type="number"
                required
                restrict="number"
                min="1"
                value={formData.capacidad}
                onChange={handleChange}
              />
            </div>

            <div className="col-12 col-md-6">
              <BaseSelect
                native
                label="Baño"
                name="bano"
                required
                value={formData.bano}
                onChange={handleChange}
                placeholder="Seleccionar tipo de baño"
                options={[
                  { value: 'propio', label: 'Propio' },
                  { value: 'compartido', label: 'Compartido' },
                ]}
              />
            </div>

            <div className="col-12">
              <div className="doctor-submit text-end d-flex justify-content-end gap-2">
                <BaseButton type="submit" variant="primary">
                  Actualizar
                </BaseButton>
                <BaseButton
                  type="button"
                  variant="secondary"
                  onClick={() => setModalEditVisible(false)}
                >
                  Cancelar
                </BaseButton>
              </div>
            </div>
          </div>
        </form>
      )}
    </Modal>

    {/* Modal de Ver Detalles */}
    <Modal
      title="Detalles del Espacio"
      open={modalViewVisible}
      onCancel={() => setModalViewVisible(false)}
      footer={[
        <BaseButton
          key="close"
          type="button"
          variant="secondary"
          onClick={() => setModalViewVisible(false)}
        >
          Cerrar
        </BaseButton>
      ]}
      width={800}
    >
      {espacioSeleccionado && (
        <div className="row">
          <div className="col-12 col-md-6">
            <div className="view-details mb-3">
              <h5>Nombre:</h5>
              <p>{espacioSeleccionado.nombre}</p>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="view-details mb-3">
              <h5>Tipo de Espacio:</h5>
              <p>{espacioSeleccionado.tipo_espacio}</p>
            </div>
          </div>

          <div className="col-12">
            <div className="view-details mb-3">
              <h5>Descripción:</h5>
              <p>{espacioSeleccionado.descripcion}</p>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="view-details mb-3">
              <h5>Precio:</h5>
              <p>S/ {parseFloat(espacioSeleccionado.precio).toFixed(2)}</p>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="view-details mb-3">
              <h5>Capacidad:</h5>
              <p>{espacioSeleccionado.capacidad} persona(s)</p>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="view-details mb-3">
              <h5>Baño:</h5>
              <p>{espacioSeleccionado.baño === 'propio' ? 'Propio' : 'Compartido'}</p>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="view-details mb-3">
              <h5>Estado:</h5>
              <p className={espacioSeleccionado.estado === 0 ? 'text-success' : 'text-danger'}>
                {espacioSeleccionado.estado === 0 ? 'Desocupado' : 'Ocupado'}
              </p>
            </div>
          </div>
        </div>
      )}
    </Modal>

    {/* Modal de éxito */}
    <Modal
      title="¡Actualización Exitosa!"
      open={showSuccessModal}
      onOk={handleSuccessModalClose}
      onCancel={handleSuccessModalClose}
      okText="Aceptar"
      cancelButtonProps={{ style: { display: 'none' } }}
      centered
    >
      <div>
        <p>El espacio se ha actualizado correctamente con los siguientes datos:</p>
        {updatedData && (
          <ul style={{ listStyleType: 'none', padding: '10px' }}>
            <li><strong>Nombre:</strong> {updatedData.nombre}</li>
            <li><strong>Descripción:</strong> {updatedData.descripcion}</li>
            <li><strong>Precio:</strong> S/ {parseFloat(updatedData.precio).toFixed(2)}</li>
            <li><strong>Capacidad:</strong> {updatedData.capacidad} persona(s)</li>
            <li><strong>Baño:</strong> {updatedData.bano === 'propio' ? 'Propio' : 'Compartido'}</li>
          </ul>
        )}
      </div>
    </Modal>
    </>
  );
};

export default EspaciosRegistros;
